<template>
  <v-main>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <h1 class="mt-n2">{{$t("User Groups")}}</h1>
        </v-flex>

        <v-flex xs12>
          <v-row>
            <v-btn class="ml-3" to="usergroups/create" color="primary">
              <v-icon left>add</v-icon>
              {{$t("New")}}
            </v-btn>
            <v-layout row wrap>
              <v-select
                class="ml-6 mt-n1 mr-3"
                v-if="isAdmin()"
                :items="corporations"
                v-model="corporation"
                :label="ct.Corporation"
                :no-data-text="ct.NoDataAvailable"
              ></v-select>

              <v-checkbox
                class="ml-3 mt-1 mr-4"
                :label="ct.Show_inactive"
                v-model="showInactive"
                :color="'primary'"
              ></v-checkbox>
            </v-layout>
          </v-row>
        </v-flex>

        <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>

        <v-flex v-else xs12>
          <v-data-table
            :headers="headers"
            :items="userGroups.filter(item => (showInactive || item.DeletedDate === null) && (corporation == 0 || item.CorporationId == corporation))"
            class="elevation-1 mt-2"
            item-key="Id"
            show-expand
          >
            <template v-slot:[`item.CreatedDate`]="{ item }">
              {{ formatDate(item.CreatedDate) }}
            </template>
            <template v-slot:[`item.DeletedDate`]="{ item }">
              {{ formatDate(item.DeletedDate) }}
            </template>

            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length">
                <v-btn color="primary" :to="{name: 'editUserGroup', params: {id: item.Id}}">
                    <v-icon left>edit</v-icon>
                    {{$t("Edit")}}
                  </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
import { app } from '@/main'
import ct from '@/core/mixins/common-translations'
import filters from '@/core/mixins/common-filters'
import * as Admin from '@/core/admin'
import * as License from '@/core/license'
import * as Security from '@/core/security'
import formatDate from '@/core/mixins/formatDate'

export default {
  mixins: [ct, filters, formatDate],
  data () {
    return {
      loading: true,
      corporation: 0,
      showInactive: false,
      corporations: [],
      userGroups: []
    }
  },

  computed: {
    headers () {
      const resAdmin = [
        {
          text: this.$t('Corp.'),
          value: 'CorporationId'
        }
      ]

      const resNotAdmin = [
        {
          text: this.$t('No.'),
          value: 'No'
        },
        {
          text: this.$t('Name'),
          value: 'Name'
        },
        {
          text: this.$t('Created'),
          value: 'CreatedDate'
        },
        {
          text: this.$t('Inactive'),
          value: 'DeletedDate'
        }
      ]
      return this.isAdmin() ? resAdmin.concat(resNotAdmin) : resNotAdmin
    }
  },

  methods: {
    isAdmin () { return Security.hasAccess([License.adminNo]) }
  },

  async mounted () {
    // We use next tick to ensure that app is initialized
    this.$nextTick(() => {
      app.$on('force-update', () => {
        // We need this to ensure that autoLogin re-renders component
        this.$forceUpdate()
      })
    })

    // Load all corporations if current user has claim 10.
    if (this.isAdmin()) {
      const corps = await Admin.loadCorporations()
      if (!corps.failed) {
        this.corporations = corps.data.map(item => {
          return {
            text: item.Name,
            value: item.Id
          }
        })
      }
      this.corporations.splice(0, 0, { text: this.$t('(ALL CORPORATIONS)'), value: 0 })
    }

    // Load all user groups for list.
    const res = await Admin.loadUserGroups()
    if (!res.failed) {
      this.userGroups = res.data
    }
    this.loading = false
  }
}
</script>
